function pageFront() {
	if ( $('.page-template-front-page') ) { //only do this on the home page! (d'oh)
		if ( $('.home-hero--videos').length ) {
			if ( $(window).width() > 600 ) {
				var videoDirectory = '/wp-content/themes/rhubarb-duplo/library/videos/home/';
				var videos = [
								"video-1.mp4", 
								"video-2.mp4",
								"video-3.mp4"
							];
				var loadedVideos = [];

				for (var i = 0; i < videos.length; i++) {
				    var url = videoDirectory + videos[i];
				    let currentVid = i;
				    let request = new XMLHttpRequest();
				    request.open("GET", url); //Request the Video!
				    request.responseType = 'blob';

				    request.onload = function() { //Video Request complete
				        if (request.readyState === XMLHttpRequest.DONE && request.status === 200) { //Check it's a good response

				        	var reader = new FileReader();		  
						  	reader.readAsDataURL(request.response); //Process the returned video

						  	reader.onloadend = function() {
			  					// Stole this code from https://stackoverflow.com/questions/41184900/set-video-objects-source-file-to-a-blob-url
							    var byteCharacters = atob(reader.result.slice(reader.result.indexOf(',') + 1));
							    var byteNumbers = new Array(byteCharacters.length);

							    for (var i = 0; i < byteCharacters.length; i++) {
							      byteNumbers[i] = byteCharacters.charCodeAt(i);
							    }

							    var byteArray = new Uint8Array(byteNumbers);
							    var blob = new Blob([byteArray], {type: 'video/mp4'});
							    var url = URL.createObjectURL(blob);
							    
							    //Ok, so this part is super hacky, bear with me and I'll try and explain what's going on!
							    //When the videos load here, they can come in a random order - so I'm using their exact bitezise to identify them...
							    if (blob.size == 4127102) { //video-1.mp4
						    		loadedVideos[0] = url;
							    } else if (blob.size == 2604238) { //video-2.mp4
						    		loadedVideos[1] = url;
							    } else if (blob.size == 5185971) { //video-3.mp4
						    		loadedVideos[2] = url;
							    }
							}
				        }
				    }

				    request.send();
				}

				//Now just poll to wait till all files are downloaded (super messy lol)
				var videoLoadCheck = setInterval(function(){
					if (loadedVideos[0] > '' && loadedVideos[1] > '' && loadedVideos[2] > '') {
						clearInterval(videoLoadCheck); //Clear the check!

						//Remove the preloader now it's loaded ye
						$('.preloader').removeClass('active');
						$('body').removeClass('popup-active');

						if ( $('#js__home-video').length ) {
							initHomeVideos();
						}
					}
				}, 250);
			}
		} else {
            initHomeSlider();

            var sliderInitCheck = setInterval(function(){
                if (typeof $.fn.slick == 'function') {
                     clearInterval(sliderInitCheck);
                    
                    //Remove the preloader now it's loaded ye
                    $('.preloader').removeClass('active');
                    $('body').removeClass('popup-active');
                   }
            }, 1000);
		}
	} 

	function initHomeVideos() {
		//Set the video source to be the first video
		var heroVideo = $('#js__home-video')[0];
	
		heroVideo.src = loadedVideos[0];
		heroVideo.play();

		//Reveal the player!
		$('body').addClass('video-loaded');
		$('.hh__video').removeClass('loading');

		//Now watch for a hover over a column - prepare to change video!
		$('.js__home-video-hover').mouseenter(function(e){
			var targetVideoCol = $(e.currentTarget);

			if(targetVideoCol.hasClass('active')){
				//Currently playing, so do nothing !
			}else{
				$('.js__home-video-hover').removeClass('active'); //Remove active from all columns
				targetVideoCol.addClass('active'); //Only add to current hover'd one

				$('.hh__video').addClass('loading');

				setTimeout(function(){
					heroVideo.src = loadedVideos[targetVideoCol.data('video')];
					setTimeout(function(){
						$('.hh__video').removeClass('loading');
					},250)
				},250)
			}
		});
	}

	function initHomeSlider() {
		$('.home-hero-slider').slick({
			autoplay: true,
	  		autoplaySpeed: 5000,
	  		pauseOnHover: false,
	  		pauseOnFocus: false,
	  		dots: false,
	  		arrows: false
		});		
	}
}